import LFSQuestionService from '@/services/LFSQuestionService'

const DEFAULT_FILTERS = { status: 'ACTIVE' }

export default {
  namespaced: true,
  state: {
    queryPending: false,
    refreshKey: 0,
    filterRefreshKey: 0,
    selectedCardIndex: null,
    activeCount: null,
    inactiveCount: null,
    filteredCount: null,
    lfsQuestions: [],
    listFilters: DEFAULT_FILTERS,
    isLoading: false
  },
  getters: {
    selectQuestionsExist(state) {
      return state.activeCount || state.inactiveCount
    },
    getLFSQuestions(state) {
      return state.lfsQuestions
    },
    getSelectedCardIndex(state) {
      return state.selectedCardIndex
    },
    selectIsLoading(state) {
      return state.isLoading
    }
  },
  mutations: {
    SET_INACTIVE_COUNT(state, count) {
      state.inactiveCount = count
    },
    INCREMENT_REFRESH_KEY(state) {
      state.refreshKey += 1
    },
    SET_SELECTED_CARD_INDEX(state, index) {
      state.selectedCardIndex = index
    },
    setLFSQuestions(state, questions) {
      state.lfsQuestions = questions
    },
    setListFilters(state, filters) {
      state.listFilters = filters
    },
    resetFilters(state) {
      state.filterRefreshKey += 1
      state.listFilters = DEFAULT_FILTERS
    },
    setDefaultFilters(state) {
      state.listFilters = DEFAULT_FILTERS
    },
    setActiveCount(state, count) {
      state.activeCount = count
    },
    setFilteredCount(state, count) {
      state.filteredCount = count
    },
    setQueryPending(state, pending) {
      state.queryPending = pending
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoading = isLoading
    }
  },
  actions: {
    async getLFSQuestions({ commit, rootState }, filters) {
      const { activeCompany } = rootState.company
      const response = await LFSQuestionService.listLFS({
        companyIds: [activeCompany._id],
        filters
      })
      const { longFormSurveyQuestions, activeCount, inactiveCount } = response.data.data

      const transformQuestion = (question) => {
        const transformedQuestion = {
          _id: question._id,
          company: question.company,
          question: question.question,
          type: question.type.toUpperCase(),
          status: question.isArchived ? 'INACTIVE' : 'ACTIVE',
          created: question.createdAt,
          children: [],
          questionData: {
            options: []
          }
        }

        if (question.responseSettings) {
          if (
            question.type === 'multiple_selection' &&
            question.responseSettings.multipleSelection
          ) {
            transformedQuestion.questionData.options =
              question.responseSettings.multipleSelection.responseOptions
          } else if (
            question.type === 'single_selection' &&
            question.responseSettings.singleSelection
          ) {
            transformedQuestion.questionData.options =
              question.responseSettings.singleSelection.responseOptions
          } else if (question.type === 'rating_scale' && question.responseSettings.ratingScale) {
            const { minimumRating, maximumRating } = question.responseSettings.ratingScale
            transformedQuestion.questionData.options = Array.from(
              { length: maximumRating - minimumRating + 1 },
              (_, i) => String(i + minimumRating)
            )
          }
        }

        if (question.followUpQuestions && question.followUpQuestions.length > 0) {
          transformedQuestion.children = question.followUpQuestions
            .map((followUp) => {
              if (followUp.longFormSurveyQuestion) {
                return transformQuestion(followUp.longFormSurveyQuestion)
              }
              return null
            })
            .filter(Boolean)
        }

        return transformedQuestion
      }

      const transformedQuestions = longFormSurveyQuestions.map(transformQuestion)

      transformedQuestions.sort((a, b) => new Date(b.created) - new Date(a.created))
      commit('setActiveCount', activeCount)
      commit('SET_INACTIVE_COUNT', inactiveCount)
      commit('setFilteredCount', transformedQuestions.length)
      commit('setLFSQuestions', transformedQuestions)
    },

    setIsLoading({ commit }, isLoading) {
      commit('SET_IS_LOADING', isLoading)
    },

    incrementRefreshKey({ commit }) {
      commit('INCREMENT_REFRESH_KEY')
    },

    setSelectedCardIndex({ getters, commit }, index) {
      if (getters.getSelectedCardIndex === index) {
        commit('SET_SELECTED_CARD_INDEX', null)
      } else {
        commit('SET_SELECTED_CARD_INDEX', index)
      }
    }
  }
}
